export default {"src":"/_next/static/media/4.3b607b19.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};